import Configs from '@/Configs';

/**
 * Module config for Admin (super-admin shell), aligned with {@link PUNCH_V2_CONFIG} shape.
 */
export const ADMIN_CONFIG = {
  name: 'admin',
  icon: 'Buildings',
  library: 'phosphor',
  routing: {
    companies: {
      path: '/admin/companies',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
    companyCreate: {
      path: '/admin/companies/create',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
    companyDetail: {
      path: '/admin/companies/:companyId',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
    campaigns: {
      path: '/admin/campaigns',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
    campaignCreate: {
      path: '/admin/campaigns/create',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
    campaignDetail: {
      path: '/admin/campaigns/:campaignId',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
  },
};
